import React, { PropTypes, Component } from 'react'
import { Link } from 'react-router-dom';
import SectionTitle from '../../resorthome/sectiontitle';
import style from './style.css'


class ReviewUs extends Component {

    render() {
        const { resort } = this.props
        return (
            <div className={ style.container }>
              <Link to={ `/guest-survey`} className={ `${style.reviewus} ${style.block}` }>
                <div className={ style.inner }>
                  <h4>Review Us</h4>
                  <p> Would your like to fill in our Guest Survey?  </p>
                </div>
                <div className={ style.img }></div>
              </Link>
                <Link to={ resort ? `/trustyou/${resort}` : `/trustyou`} className={ `${style.trustyou} ${style.block}` }>
                    <div className={ style.inner }>
                        <h4>Guest Reviews</h4>
                        <p> Checkout our GUEST REVIEWS  </p>
                    </div>
                    <div className={ style.img }></div>
                </Link>
            </div>
        )
    }
}

export default ReviewUs



// WEBPACK FOOTER //
// ./src/components/homescreen/reviewus/index.js